<template>
  <div class="home-page">
    <v-container fill-height v-if="authenticated">
      <v-row justify="center" align="center">
        <v-col cols="12" md="12" lg="8" xl="6">
          <v-card class="elevation-2 pt-16 pa-8 mx-auto" style="max-width: 500px" v-if="showCode">
            <v-form ref="digit-code-form" :lazy-validation="true" @submit.prevent="submitCode()">
              <v-card-text class="bg-white text-area">
                <v-text-field
                  outlined
                  v-model="code"
                  :rules="digitCodeRules"
                  :counter="6"
                  :disabled="submitingCode"
                  :label="translate($store.getters.content.enter_code)"
                  required
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="back()" text large class="float-right" v-if="showBackBtn">
                  <v-icon class="ma-0" left>mdi-chevron-left</v-icon>
                  {{ translate($store.getters.content.back) }}
                </v-btn>
                <v-btn color="primary" @click="submitCode()" :disabled="submitingCode" :loading="submitingCode" class="float-right" large>
                  {{ translate($store.getters.content.next) }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
          <v-row justify="center" align="center" v-if="showCases">
            <v-col cols="12" lg="6" md="6" v-for="(caseItem, i) in patientCases" v-bind:key="i">
              <v-card class="pl-5 pr-5 pt-2 pb-2 case-card">
                <v-list-item>
                  <v-list-item-content class="pb-0 pt-0">
                    <div class="overline mb-0 pt-0">{{ caseItem.name }}</div>
                    <v-list-item-title class="headline mb-2 mt-2 grey--text text--darken-2">
                      <v-icon class="mb-1">mdi-account</v-icon>
                      {{ caseItem.firstname }} {{ caseItem.lastname }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-card-text class="bg-white text-area">
                  <v-alert dense outlined type="success" border="left" v-if="surveyFilled[i]"
                    >{{ translate($store.getters.content.survey_filled) }}
                    <span v-if="appointmentBooked[i]">
                      <br />
                      {{ translate($store.getters.content.appointment_booked) }}
                    </span></v-alert
                  >
                  <v-alert dense outlined type="warning" border="left" v-if="infoMissing(caseItem)">
                    {{ translate($store.getters.content.no_doctors_info) }}
                    <br />
                    {{ translate($store.getters.content.update_user_info) }}
                  </v-alert>
                  <v-alert dense outlined type="warning" border="left" v-else-if="surveyFilled[i] && !appointmentBooked[i]">
                    {{ translate($store.getters.content.needs_to_book_appointment) }}
                  </v-alert>
                </v-card-text>
                <v-row align="end">
                  <v-col>
                    <v-btn
                      @click="selectCase(caseItem, i)"
                      color="primary"
                      class="elevation-0 ms-2 float-right"
                      outlined
                      :disabled="disabled(i, caseItem)"
                    >
                      {{ translate($store.getters.content.select) }}
                      <v-icon left class="ms-1">mdi-arrow-right</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- FAB BTN -->
      <v-btn
        elevation="5"
        color="primary"
        :fab="scrollTop ? false : true"
        class="ma-2 float-right add-btn font-weight-bold"
        large
        :rounded="scrollTop ? true : false"
        v-if="showAddBtn"
        @click="addUser()"
      >
        <v-icon :left="scrollTop ? true : false" dark>mdi-plus</v-icon>
        <span v-if="scrollTop">{{ translate($store.getters.content.add_person) }}</span>
      </v-btn>
    </v-container>
    <v-container class="pt-16" v-if="!authenticated && authenticated != null">
      <v-row justify="center" align="start">
        <v-col cols="12" lg="8" xl="6">
          <v-alert prominent icon="mdi-information" text type="info">
            <div class="headline">{{ translate($store.getters.content.survey_title) }}</div>
            <div class="subtitle">{{ translate($store.getters.content.fill_in_survey) }}</div>
          </v-alert>

          <div class="auth-btn-wrapper">
            <v-btn @click="login()" color="primary" large class="d-block mx-auto mt-8">
              {{ translate($store.getters.content.login) }}
              <v-icon right>mdi-login-variant</v-icon>
            </v-btn>
            <div class="divider"></div>
            <div class="or-divider">{{ translate($store.getters.content.or) }}</div>
            <v-btn @click="register()" large class="d-block mx-auto mt-4">
              {{ translate($store.getters.content.register) }}
              <v-icon right>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SharedFunctions from '@/mixins/SharedFunctions.vue';

export default {
  mixins: [SharedFunctions],
  components: {},
  data() {
    return {
      showCode: false,
      showCases: false,
      submitingCode: false,
      showAddBtn: false,
      showBackBtn: false,
      //digitCode: null,
      code: '',
      codes: [],
      digitMax: 6,
      scrollTop: true,
      digitCodeRules: [
        (v) => !!v || this.$store.getters.content.required[this.$store.state.config.selectedLanguage],
        (v) =>
          (v && v.length <= 6) ||
          this.$store.getters.content.code_should_be[this.$store.state.config.selectedLanguage] +
            '  ' +
            this.digitMax +
            ' ' +
            this.$store.getters.content.digits[this.$store.state.config.selectedLanguage],
        (v) =>
          (v && v.length >= 6) ||
          this.$store.getters.content.code_should_be[this.$store.state.config.selectedLanguage] +
            '  ' +
            this.digitMax +
            ' ' +
            this.$store.getters.content.digits[this.$store.state.config.selectedLanguage],
      ],
      surveyFilled: [],
      appointmentBooked: [],
      appointmentCode: null,
    };
  },
  created() {
    //this.$router.push({ name: 'SeroSurveyPage' })
    if (this.userObject != null) {
      this.getPatiencases();
    }
    this.checkIfCodeInUrl();
    this.getLanguage();
    window.addEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.$store.commit('SET_LOCATIONS', null);
    this.$store.commit('SET_LOCATION', null);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    userObject(val) {
      if (val != null) {
        this.getPatiencases();
      }
    },
  },
  computed: {
    keycloak() {
      return this.$store.state.keycloak;
    },
    patientCases() {
      return this.$store.state.intakeFormData.patientCases;
    },
    patientCase() {
      return this.$store.getters.getPatientCase;
    },
    userObject: {
      get() {
        return this.$store.getters.userObject;
      },
      set(value) {
        this.$store.commit('SET_USER_OBJECT', value);
      },
    },
    authenticated() {
      return this.$store.getters.authenticated;
    },
  },
  methods: {
    checkIfCodeInUrl() {
      const url = new URL(window.location.href);
      const code = url.searchParams.get('digit-code');
      if (code) {
        this.code = code;
      }
    },
    submitCode() {
      if (this.$refs['digit-code-form'].validate()) {
        this.submitingCode = true;
        const data = {
          code: this.code,
        };

        this.$store.dispatch('SUBMIT_DIGIT_CODE', data).then((data) => {
          const patientCaseId = this.patientCase.patientCaseId;
          this.submitingCode = false;
          if (data) {
            //this.$store.commit('SET_CODE_INFO', this.code);
            this.setCodeSurvey(data[0], patientCaseId);
            //this.$router.push({ name: 'SeroSurveyPage' });
            this.$router.push({
              name: 'SeroSurveyPage',
              params: { formSubmitted: this.formSubmitted },
            });
          }
        });
        //.finally(() => (this.submitingCode = false));
      }
    },
    getLanguage() {
      const languageLocalStorage = localStorage.getItem('language');

      if (this.$store.state.config.selectedLanguage == null && languageLocalStorage != null) {
        this.$store.commit('SET_SELECTED_LANGUAGE', languageLocalStorage);
      } else {
        this.$store.commit('SET_SELECTED_LANGUAGE', this.$store.state.config.defaultLanguage);
      }
    },
    getPatiencases() {
      this.$store.dispatch('GET_CASES').then(() => {
        if (this.patientCases.length <= 0) {
          this.showCode = false;
        } else {
          for (let i = 0; i < this.patientCases.length; i++) {
            this.checkForm(this.patientCases[i].patientCaseId, i);
          }
          this.showCases = true;
          this.showCode = false;
          this.showAddBtn = true;
        }
      });
    },
    selectCase(caseItem, i) {
      this.$store.commit('RESET_INTAKE_FORM_DATA', { state: this.$store.state });
      this.$store.commit('SET_PATIENT_CASE', caseItem);
      if (this.codes[i] != undefined) {
        this.$store.commit('SET_CODE_INFO', this.codes[i]);

        const payload = {
          code: this.codes[i].code,
        };
        this.$store.dispatch('GET_APPOINTMENT_CODE_INFO', payload);
      } else {
        this.$store.commit('SET_CODE_INFO', null);
      }

      if (this.surveyFilled[i]) {
        this.$router.push({ name: 'Locations' });
      } else {
        this.$store.commit('SET_CURRENT_STEP_INTAKE_FORM', 1);
        this.showCode = true;
        this.showCases = false;
        this.showBackBtn = true;
        this.showAddBtn = false;
        this.code = this.codes[i];
      }
    },
    checkForm(patientCaseId, i) {
      let surveyFilled = this.surveyFilled;
      this.$store.dispatch('CHECK_FORM', patientCaseId).then((data) => {
        if (data.length > 0) {
          surveyFilled[i] = true;
          for (let k in data) {
            this.codes[i] = data[k].code;
          }

          let appointmentBooked = this.appointmentBooked;
          this.$store.dispatch('GET_APPOINTMENT', patientCaseId).then((data) => {
            if (data) {
              for (let k in data) {
                if (data[k].agendaSlot != undefined) {
                  appointmentBooked[i] = true;
                } else {
                  appointmentBooked[i] = false;
                }
              }
            }
            this.$set(this.appointmentBooked, appointmentBooked);
          });
        } else {
          surveyFilled[i] = false;
        }
        this.$set(this.surveyFilled, surveyFilled);
      });
    },
    back() {
      this.showCode = false;
      this.showCases = true;
      this.showBackBtn = false;
      this.showAddBtn = true;
    },
    addUser() {
      this.$router.push({ name: 'CreateUser' });
    },
    setCodeSurvey(value, patientCaseId) {
      if (patientCaseId != '') {
        this.$store.commit('SET_CODE_INFO', value);
        this.$store.commit('SET_INTAKE_FORM_DATA_ITEM', { key: 'code', value: value.code });
      }
    },
    async login() {
      //const loginUrl = this.keycloak.createLoginUrl({ scope: 'offline_access' });
      const loginUrl = this.keycloak.createLoginUrl();
      window.location.href = loginUrl;
    },
    infoMissing(patientCase) {
      return patientCase.doctorEntry == undefined ? true : false;
    },
    register() {
      this.$router.push({ name: 'Register' });
    },
    handleScroll() {
      if (window.scrollY > 40) {
        this.scrollTop = false;
      } else this.scrollTop = true;
    },
    disabled(i, patientCase) {
      if ((this.surveyFilled[i] && this.appointmentBooked[i]) || this.infoMissing(patientCase)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.add-btn {
  position: fixed;
  right: 20px;
  bottom: 140px;
  z-index: 0;
}

/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  .add-btn {
    right: 0px;
    bottom: 20px;
    z-index: 10;
  }
}

.auth-btn-wrapper {
  margin-top: 40px;
  padding: 20px;
  button {
    width: 100%;
    max-width: 277px;
  }
  .or-divider {
    text-align: center;
    margin-top: 14px;
    text-transform: uppercase;
    color: grey;
    background: whitesmoke;
    z-index: 1;
    position: relative;
    display: block;
    margin: 20px auto;
    width: 42px;
  }
  .divider {
    position: relative;
    bottom: -32px;
    z-index: 0;
    border-bottom: 1px solid lighten(grey, 30%);
  }
}

.case-card {
  border-radius: 20px !important;
  .v-alert {
    font-size: 12px !important;
    margin-bottom: 6px !important;
    padding: 6px !important;
  }
  .v-application--is-ltr .v-alert__icon {
    margin-left: 5px !important;
  }
  .v-list-item__title,
  .v-list-item__subtitle {
    white-space: normal;
  }
  .v-card__text {
    padding: 0;
    height: 85px;
    line-height: normal;
  }
}
</style>
